import React from 'react';
import { Openfin } from './OpenfinAdapter';

const OpenfinContext = React.createContext(Openfin);
export const OpenfinProvider = OpenfinContext.Provider;
export const OpenfinConsumer = OpenfinContext.Consumer;

export default OpenfinContext;
